module.exports = __webpack_public_path__ + "static/media/header-mobile.21c8a8c2.png";